import React from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../appConfig';
import { getCatalog } from '../translationCatalogWrapper';

export const translate = (key, lang = null, replacements = {}) => {
  const catalog = getCatalog();
  let result = lang && catalog[key] && catalog[key][lang] ? catalog[key][lang] : key;
  Object.entries(replacements).forEach(([k, v]) => {
    result = result.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
  });
  return result;
};

export const getUserLang = (user) => {
	const config = getConfig();

	return localStorage.getItem('locale') ? localStorage.getItem('locale') : config.localization && config.localization.defaultLocale ? config.localization.defaultLocale : 'en';
};
export const withTranslation = (WrappedComponent) => {
  class Translated extends React.Component {
    constructor(props) {
      super(props);
      this.__ = this.__.bind(this);
    }
    __(key, replacements = {}) {
      const { lang } = this.props;
      return translate(key, lang, replacements);
    }
    render() {
      return <WrappedComponent __={this.__} {...this.props} />;
    }
  }

  const stateToProps = (state) => {
    const { profile } = state.profile;
    return {
      lang: getUserLang(profile),
    };
  };

  return connect(stateToProps)(Translated);
};
